import { ContentLogKeys, EngagementKeys, IssueKeys, ServiceKeys } from './constants/IssueAndServiceKeys';
import { FlatContentLog, FlatEngagement, FlatIssue, FlatService } from './types';

export function isFlatIssue(obj: any): obj is FlatIssue {
  return obj?.cells?.[IssueKeys.journalist] !== undefined && obj?.cells?.[IssueKeys.outlet] !== undefined;
}

export function isFlatService(obj: any): obj is FlatService {
  return obj?.cells?.[ServiceKeys.service] !== undefined;
}

export function isFlatEngagement(obj: any): obj is FlatEngagement {
  return (
    obj?.cells?.[EngagementKeys.organization] !== undefined ||
    obj?.cells?.[EngagementKeys.communityMember] !== undefined ||
    obj?.cells?.[EngagementKeys.notes] !== undefined
  );
}

export function isFlatContentLog(obj: any): obj is FlatContentLog {
  if (!obj?.cells) {
    return false;
  }

  if (isFlatService(obj) || isFlatEngagement(obj) || isFlatIssue(obj)) {
    return false;
  }

  return obj.cells[ContentLogKeys.topic] !== undefined;
}
